<!--go-chat-duplication-->
<app-dialog #dialog
            (confirm)="confirmButtonClicked()"
            confirmButtonText="Refresh"
            title="Application Error">
            Application has encountered a fatal error. (GOCORE_RUNTIME_EXCEPTION)
            Please refresh the page and try again.  
</app-dialog>
